import * as API from './API'
import {formDataRequest} from "./API";

export default {

    //일거리 현황 리스트
    async getJobList(page, size) {
        let parameters = {
            method: 'GET',
            path: '/api/topics',
            params: {
                'page': page,
                'size': size
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    //일거리 현황 상세
    async getJobDetail(uuid) {
        let parameters = {
            method: 'GET',
            //path: '/api/topics/' + uuid,
            path: '/v1/api/topics/' + uuid,
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    //출품하기
    async entrySubmit(args) {
        let parameters = {
            method: 'POST',
            path: '/api/submission/',
            data: args.formData,
            params: {}
        }
        const apiResponse = await API.formDataRequest(parameters)
        return apiResponse
    },

    //출품 현황 리스트
    async getEntryList(page, size) {
        let parameters = {
            method: 'GET',
            path: '/api/submission/',
            params: {
                page: page,
                size: size,
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    //프로젝트 파일 등록
    async submitProjectFile(args) {
        let parameters = {
            method: 'POST',
            path: '/api/submission/project-file/' + args.uuid,
            data: args.formData,
            params: {}
        }
        const apiResponse = await API.formDataRequest(parameters)
        return apiResponse
    }

}



// WEBPACK FOOTER //
// ./src/service/jobAPI.js